export const toArray = (value) => (Array.isArray(value) ? value : []);

export const collectArrayCandidates = (source, keys = []) => {
  if (!source || typeof source !== 'object') {
    return [];
  }

  return keys.flatMap((key) => toArray(source[key]));
};
